import { LoadingButton } from '@mui/lab';
import { Box, Typography, useTheme, Button, Stack } from '@mui/material';
import { MessageQuestion } from 'iconsax-react';

const ConfirmContent = ({
  background = 'transparent',
  height = 'auto',
  width = 'auto',
  boxWidth = 300,
  title = 'Confirming',
  message = 'Are you sure?',
  icon,
  onConfirm,
  onClose,
  loading = false,
  buttonText = 'Confirm',
  buttonTextLoading = 'Confirming...',
}: {
  height?: string | number;
  width?: string | number;
  boxWidth?: string | number;
  message?: string;
  title?: string;
  icon?: React.ReactNode;
  background?: string;
  onConfirm: () => void;
  onClose: () => void;
  buttonText?: string;
  buttonTextLoading?: string;
  loading?: boolean;
}) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'grid',
        placeItems: 'center',
        height: height,
        width: width,
      }}
    >
      <Box
        sx={{
          background: background || theme.palette.background.paper,
          borderRadius: 2,
          width: boxWidth,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'start',
          alignItems: 'center',
        }}
      >
        {icon || (
          <MessageQuestion
            variant='Bulk'
            size={24}
            color={theme.palette.info.main}
          />
        )}
        <Typography variant='body1' fontWeight='bold' textAlign='center' mt={1}>
          {title}
        </Typography>
        <Typography
          variant='body2'
          fontWeight='normal'
          textAlign='center'
          mb={2}
        >
          {message}
        </Typography>
        <Stack direction='row' spacing={1} width='100%'>
          {onClose && (
            <Button
              color='inherit'
              onClick={onClose}
              fullWidth
              sx={{
                bgcolor: 'action.hover',
              }}
            >
              Cancel
            </Button>
          )}
          <LoadingButton
            onClick={onConfirm}
            variant='contained'
            disabled={loading}
            loading={loading}
            fullWidth
            loadingIndicator={buttonTextLoading}
          >
            {buttonText}
          </LoadingButton>
        </Stack>
      </Box>
    </Box>
  );
};

export default ConfirmContent;
